/**
 * Created by piotr.pozniak@thebeaverhead.com on 19/02/2024
 */

import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

/**
 *
 * @param {string} icon
 * @param {string|node} label
 * @param {string} href
 * @param {function } onClick
 * @param {boolean=false} disabled
 * @param {string="_self"} target
 * @param {string} toggleId
 * @returns {Element}
 * @constructor
 */
const HamburgerItem = ({
  icon,
  label,
  href,
  onClick,
  disabled = false,
  target = "_self",
  toggleId,
}) => {
  /**
   *
   * @type {(function(*): void)|*}
   * @private
   */
  const _onClick = useCallback(
    (e) => {
      if (onClick) {
        e.preventDefault();
        // e.stopPropagation();

        onClick(e);
      }
      window.$(`#${toggleId}`).dropdown("hide");
    },
    [onClick]
  );

  const Component = href && href.startsWith("http") ? "a" : Link;
  return (
    <Component
      className={classNames("dropdown-item d-flex align-items-center", {
        "pointer-events-none": disabled,
        "text-muted": disabled,
        "cursor-wait": disabled,
      })}
      to={href || "#"}
      href={href || "#"}
      title="Delete"
      onClick={_onClick}
      disabled={disabled}
      target={target}
    >
      <i className="material-icons icon-sm m-r-5" aria-hidden={true}>
        {icon}
      </i>{" "}
      {label}
    </Component>
  );
};

export default HamburgerItem;
